"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const DescriptionHeader_1 = __importDefault(require("../../molecules/DescriptionHeader"));
function InfoboxDescriptionPanel({ isOpen, onClose, descriptionText, }) {
    const { t } = (0, i18n_1.useTranslation)();
    const isLower = (0, ui_1.useScreenBreakpoint)(ui_1.sizeMainScreen.tablet);
    return (isOpen && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!isLower && ((0, jsx_runtime_1.jsx)(DescriptionHeader_1.default, { titleText: t(i18n_1.Strings.infoBox.tabs.info), onClose: onClose, icon: ui_1.Icons.Back_Arrow, "data-e2e": 'InfoboxDescriptionPanel_DescriptionHeader' })), (0, jsx_runtime_1.jsx)(ui_1.InfoContainer, { descriptionText: descriptionText, "data-e2e": 'InfoboxDescriptionPanel_InfoContainer' })] })));
}
exports.default = InfoboxDescriptionPanel;
